module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['reply-wrapper', !_vm.replyInfo.parent_id ? 'is-reply-comment' : _vm.isShow ? 'is-show' : '']
  }, [_c('div', {
    staticClass: "reply-user-avatar"
  }, [(_vm.userInfo.avatar.indexOf('?') === 0) ? _c('img', {
    attrs: {
      "width": "30",
      "height": "30",
      "src": require("../../images/personal_center/avatar_default.png")
    },
    on: {
      "click": _vm.goUserPage
    }
  }) : _c('img', {
    attrs: {
      "width": "30",
      "height": "30",
      "src": _vm.userInfo.avatar
    },
    on: {
      "click": _vm.goUserPage
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "reply-content"
  }, [_c('p', [_vm._v("回复"), _c('span', {
    staticClass: "nick-name"
  }, [_vm._v(_vm._s(_vm.replyInfo.commented_by.nick_name))])]), _vm._v(" "), _c('change-editor', {
    staticClass: "reply-editor",
    attrs: {
      "domId": ("replyEditor" + (_vm.replyInfo.id)),
      "parentId": _vm.replyInfo.parent_id || 0,
      "isFullScreen": true,
      "questionValue": _vm.filterXSS(_vm.replyInfo.replyContent)
    },
    on: {
      "onChangeEditor": _vm.onChangeEditor
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "send-msg"
  }, [_c('span', {
    staticClass: "cancel-btn",
    on: {
      "click": function($event) {
        return _vm.onCancelComment(_vm.replyInfo)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    class: ['comment-btn', {
      'disabled': !_vm.isAllowReply
    }],
    on: {
      "click": function($event) {
        return _vm.replyComment(_vm.replyInfo)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.isAnswer ? '提交回复' : '提交') + "\n            ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-99d2fa10!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/community/reply.vue
// module id = Wq7o
// module chunks = 12